// extracted by mini-css-extract-plugin
export default {"cardDetails":"CardDetails_cardDetails__vnqd3"};